import { connect } from 'react-redux';
import { Form, Select, TimePicker,Button } from 'antd';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useRef, useState } from 'react';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';
import { checkDecimalValue } from '../../../Utils/FormCalls';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import dayjs from 'dayjs';

const { Option } = Select;

const WFHeader = (props) => {
  const { record: initialRecord, translationCache, workTypes, onFinish } = props;
  const [record, setRecord] = useState(initialRecord);
  const formRef = useRef();

  useEffect(() => {
    const updatedRecord = {
      ...initialRecord,
      'Min&Sec':
        initialRecord && initialRecord['Min&Sec'] !== undefined
          ? dayjs(initialRecord['Min&Sec'], 'mm:ss')
          : ''
    };
    setRecord(updatedRecord);
    formRef.current.setFieldsValue(updatedRecord);
  }, [initialRecord]);

  return (
    <Form
      name="WFHeader"
      ref={formRef}
      onFinish={onFinish}
      onKeyDown={(e) => {
        e.key === 'Enter' && e.preventDefault();
      }}
      initialValues={record || {}}
      layout="horizontal"
      labelCol={{ flex: '130px' }}
      labelAlign="right"
      labelWrap
    >
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item
          label={translation(translationCache, constant.workFlowName)}
          name="WorkFlowName"
          style={{ width: '100%', flex: '50%' }}
          rules={[
            {
              required: true,
              message: translation(translationCache, 'Please Input Work Flow Name!')
            }
          ]}
        >
          <InputComponent
            placeholder={translation(translationCache, 'Input Work Flow Name')}
            style={{ width: '70%' }}
          />
        </Form.Item>

        <Form.Item
          label={translation(translationCache, constant.workFlowType)}
          name="WorkTypeId"
          style={{ width: '100%', flex: '50%' }}
          rules={[
            {
              required: true,
              message: translation(translationCache, 'Please Select Work Type!')
            }
          ]}
        >
          <Select
            placeholder={translation(translationCache, 'Select Work Type')}
            style={{ width: '70%' }}
          >
            {workTypes &&
              Array.isArray(workTypes) &&
              workTypes.map((param, index) => (
                <Option key={index} value={param.Value}>
                  {translation(translationCache, param.Key)}
                </Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={translation(translationCache, constant.hours)}
          name="Hours"
          style={{ width: '100%', flex: '50%' }}
          rules={[
            { required: false, message: 'Please Enter Hours!' },
            {
              validator: (_, value) =>
                checkDecimalValue(_, value, 'Hours', record, { validateDecimal: true })
            }
          ]}
        >
          <InputNumberComponent
            placeholder={translation(translationCache, 'Input Hours')}
            min={0}
            max={24}
            style={{ width: '70%' }}
          />
        </Form.Item>

        <Form.Item
          name="Min&Sec"
          style={{ width: '100%', flex: '50%' }}
          label={translation(translationCache, constant.minSec)}
          rules={[
            {
              type: 'object',
              required: true,
              message: 'Please select time!'
            }
          ]}
        >
          <TimePicker
            placeholder={translation(translationCache, constant.selectTime)}
            format={'mm:ss'}
            style={{ width: '70%' }}
            value={null}
          />
        </Form.Item>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <Form.Item>
          <Button htmlType="submit">
            {record && record.Id
              ? translation(translationCache, constant.update)
              : translation(translationCache, constant.save)}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WFHeader);